import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

function trim(value: unknown): string {
  return value === null || value === undefined ? '' : String(value).trim();
}

function buildLocalAddress(parts: {
  blockNo?: unknown;
  streetName?: unknown;
  buildingName?: unknown;
  level?: unknown;
  unit?: unknown;
  postalCode?: unknown;
}): string {
  const blockNo = trim(parts.blockNo);
  const streetName = trim(parts.streetName);
  const buildingName = trim(parts.buildingName);
  const level = trim(parts.level);
  const unit = trim(parts.unit);
  const postalCode = trim(parts.postalCode);
  const line1 = [blockNo, streetName].filter(Boolean).join(' ').trim();
  const line2 = level || unit ? `#${[level, unit].filter(Boolean).join('-')}` : '';
  return [line1, line2, buildingName, postalCode ? `SINGAPORE ${postalCode}` : ''].filter(Boolean).join(', ');
}

function buildForeignAddress(line1: unknown, line2: unknown): string {
  return [trim(line1), trim(line2)].filter(Boolean).join(', ');
}

function formatResidentialAddress(raw: any): string {
  if (typeof raw === 'string') return trim(raw);
  const contact = raw && typeof raw === 'object' ? raw : {};
  const local = buildLocalAddress({
    blockNo: contact.blockNo,
    streetName: contact.streetName,
    buildingName: contact.buildingName,
    level: contact.addrLevel,
    unit: contact.addrUnit,
    postalCode: contact.postalCode,
  });
  return local || buildForeignAddress(contact.foreignAddressLine1, contact.foreignAddressLine2);
}

function formatServiceAddress(raw: any): string {
  if (typeof raw === 'string') return trim(raw);
  const contact = raw && typeof raw === 'object' ? raw : {};
  const local = buildLocalAddress({
    blockNo: contact.altBlockNo,
    streetName: contact.altStreetName,
    buildingName: contact.altBuildingName,
    level: contact.altAddrLevel,
    unit: contact.altAddrUnit,
    postalCode: contact.altPostalCode,
  });
  return local || buildForeignAddress(contact.altForeignAddressLine1, contact.altForeignAddressLine2);
}

/** B32101 / B32001 — Director appointment register summary */
const appointDirectorDetailMap = {
  title: 'New Director Details',
  fields: [
    {
      label: 'Full Name',
      key: [
        'directorName',
        'officerName',
        'contactData.contactName',
      ],
    },
    {
      label: 'NRIC / FIN / Passport No',
      key: [
        'directorIdentificationNo',
        'contactData.contactRegNo',
      ],
    },
    {
      label: 'Date of Birth',
      key: [
        'directorDateOfBirth',
        'contactData.dateOfBirth',
      ],
    },
    {
      label: 'Nationality',
      key: [
        'directorNationality',
        'contactData.nationalityText',
      ],
    },
    { label: 'Email', key: ['directorEmail', 'contactData.contactEmail'] },
    { label: 'Contact No', key: ['directorContactNo', 'contactData.mobileNo'] },
    {
      label: 'Date of Appointment',
      key: [
        'appointmentEffectiveDate',
        'appointmentDate',
        'appointedDate',
      ],
    },
    {
      label: 'Residential Address',
      key: ['directorAddress', 'contactData'],
      format: formatResidentialAddress,
    },
    {
      label: 'Contact Address',
      key: ['directorAlternateAddress', 'contactData'],
      format: formatServiceAddress,
    },
  ],
};

/** B32103 — Company Secretary appointment (same form field keys as director flows; UI title only differs) */
const appointSecretaryDetailMap = {
  ...appointDirectorDetailMap,
  title: 'New Company Secretary Details',
};

registerRegisterDetail('B32101', appointDirectorDetailMap);
registerRegisterDetail('B32103', appointSecretaryDetailMap);
registerRegisterDetail('B32001', appointDirectorDetailMap);
